module.exports = __webpack_public_path__ + "img/Logos-22.d78782bc.png";